export default __webpack_public_path__ + "static/history-img-1-bd3208cba3b0373a5a587a8cba28f669.png";